import { useMemo } from 'react'
import { useContextSelector } from 'use-context-selector'
import { FilterAccordionChip } from '../SideFilterSelect/SideFilterSelect.styles'
import { SideFilterSelectContext } from '../SideFilterSelect/SideFilterSelectContext'
import { PropositionTypeGroups } from '@enums/PropositionTypeEnum'

export function PropositionTypeFilterCounter(): JSX.Element {
  const selecteds = useContextSelector(
    SideFilterSelectContext,
    (s) => s.selecteds
  )

  // Count how many groups have all their acronyms selected
  const selectedGroupsCount = useMemo(() => {
    let count = 0
    Object.values(PropositionTypeGroups).forEach((group) => {
      const isGroupSelected = group.acronyms.every((acronym) =>
        selecteds.includes(acronym)
      )
      if (isGroupSelected) {
        count += 1
      }
    })
    return count
  }, [selecteds])

  if (selectedGroupsCount <= 0) return <div />
  return <FilterAccordionChip size="small" label={selectedGroupsCount} />
}
